
export default {
  name: 'App',
}
